import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Hidden from '@mui/material/Hidden'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import {faStickyNote} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

const useStyles = makeStyles(infoBarStyles)

export default function InfoBar ({context, closeDialog}) {

  const classes = useStyles()
  const {translate} = context

  return (
    <Box className={classes.root}>
      <Box className={clsx(classes.middle, classes.icon)}>
        <Hidden smDown>
            <FontAwesomeIcon icon={faStickyNote} />
        </Hidden>
      </Box>
      <Box className={clsx(classes.middle, classes.label, classes.info)}>
        {translate('annotations')}
      </Box>
      <Box className={clsx(classes.middle, classes.close)}>
        <IconButton onClick={closeDialog} className={classes.closeButton} size="large">
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

function infoBarStyles (theme) {
  return {
    root: {
      display: 'flex',
      borderBottom: 'solid 1px #dbe3e6',
      flexShrink: 0,
      padding: 15
    },
    icon: {
      color: '#4f576e'
    },
    info: {
      flexGrow: 1,
    },
    close: {
      color: '#69738',
      padding: '0 6px',
      "& svg": {
        fontSize: '18pt'
      }
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    label: {
      paddingTop: '4px',
      marginLeft: '20px',
      fontSize: '14pt',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(15),
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
      },
    },
  };
}


